const $$splitErrorComponentImporter = () => import('/home/runner/work/storebuilder/storebuilder/src/routes/signup.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/runner/work/storebuilder/storebuilder/src/routes/signup.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { isOAuthTokenValid } from '@api/auth/oauthToken';
import { adminDashConfig } from '@api/auth/config';
export interface SignupSearchParams {
  utm_source?: string;
  utm_medium?: string;
  utm_term?: string;
  utm_campaign?: string;
}
export const Route = createFileRoute('/signup')({
  validateSearch: (search: Record<string, unknown>): SignupSearchParams => ({
    utm_source: typeof search.utm_source === 'string' ? search.utm_source : undefined,
    utm_medium: typeof search.utm_medium === 'string' ? search.utm_medium : undefined,
    utm_term: typeof search.utm_term === 'string' ? search.utm_term : undefined,
    utm_campaign: typeof search.utm_campaign === 'string' ? search.utm_campaign : undefined
  }),
  beforeLoad: ({
    location
  }) => {
    if (isOAuthTokenValid()) {
      window.location.href = `${adminDashConfig.baseUrl}/dashboard/stores`;
      return;
    }
    if (location.pathname === '/signup' || location.pathname === '/signup/') {
      throw redirect({
        to: '/signup/step1',
        search: location.search
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});
if (import.meta.hot) {
  import.meta.hot.accept(newModule => {
    if (Route && newModule && newModule.Route) {
      (function handleRouteUpdate(oldRoute, newRoute) {
        newRoute._path = oldRoute._path;
        newRoute._id = oldRoute._id;
        newRoute._fullPath = oldRoute._fullPath;
        newRoute._to = oldRoute._to;
        newRoute.children = oldRoute.children;
        newRoute.parentRoute = oldRoute.parentRoute;
        const router = window.__TSR_ROUTER__;
        router.routesById[newRoute.id] = newRoute;
        router.routesByPath[newRoute.fullPath] = newRoute;
        router.processedTree.matchCache.clear();
        router.processedTree.flatCache?.clear();
        router.processedTree.singleCache.clear();
        router.resolvePathCache.clear();
        walkReplaceSegmentTree(newRoute, router.processedTree.segmentTree);
        const filter = m => m.routeId === oldRoute.id;
        if (router.state.matches.find(filter) || router.state.pendingMatches?.find(filter)) {
          router.invalidate({
            filter
          });
        }
        function walkReplaceSegmentTree(route, node) {
          if (node.route?.id === route.id) node.route = route;
          if (node.index) walkReplaceSegmentTree(route, node.index);
          node.static?.forEach(child => walkReplaceSegmentTree(route, child));
          node.staticInsensitive?.forEach(child => walkReplaceSegmentTree(route, child));
          node.dynamic?.forEach(child => walkReplaceSegmentTree(route, child));
          node.optional?.forEach(child => walkReplaceSegmentTree(route, child));
          node.wildcard?.forEach(child => walkReplaceSegmentTree(route, child));
        }
      })(Route, newModule.Route);
    }
  });
}